import { Grid, makeStyles } from '@material-ui/core';
import {useCallback, useEffect} from 'react';
import {
  Label as LabelIcon,
  DynamicFeed as DynamicFeedIcon,
} from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import QCXFocusLock from "../../../components/focus-lock/QCXFocusLock";
import QCXMainLayout from "../../../components/main-layout/QCXMainLayout";
import QCXCardMenu from '../../../shared-components/card-menu/QCXCardMenu';
import { setHouseHawbType, setHouseHblType, setOperationImportacao as setOperationImportacaoHouse  } from '../../../features/house/HouseSlice';
import { setBlType, setMasterType, setOperationImportacao as setOperationImportacaoMaster} from '../../../features/master/masterSlice';


const useStyles = makeStyles((theme) => ({
  cardMenuContainer: {
    marginTop: theme.spacing(0),
  },
  cardMenu: {
    width: theme.spacing(100),
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  subNested: {
    paddingLeft: theme.spacing(8),
  },
  active: {
    display: 'flex!important',
  },
  noActive: {
    display: 'none!important',
    transformOrigin: '0 0 0!important',
  },
}));

export default function AgenciamentoImportacaoPageMaritmo({ authInfo = {} }) {

  const { t } = useTranslation();
  const classes = useStyles();

  const dispatch = useDispatch();

  const breadcrumbs = [
    {
      link: {
        to: '/',
        name: t('com.muralis.qcx.inicio'),
      },
    },
    {
      text: {
        name: 'Agenciamento Marítimo Importação',
      },
    }
  ];

  dispatch(setOperationImportacaoHouse());
  dispatch(setOperationImportacaoMaster());

  const userHasAnyRole = useCallback((mainRoles = []) => (
    authInfo?.roles?.some((role) => mainRoles?.find((item) => role?.startsWith(item)))
  ), [authInfo]);


  return (
    <>
      <QCXMainLayout
        pageIcon={<LabelIcon />}
        pageTitle='Agenciamento Marítimo Importação'
        breadcrumbs={breadcrumbs}
        authInfo={authInfo}
      >
        <Grid className={classes.cardMenuContainer} item container justify="center" xs={12} sm={12} md={12} xl={12}>
          <QCXFocusLock>
          <Grid container style={{ maxWidth: '1920px' }}>
            
               {userHasAnyRole(['agenciamento-importacao-maritimo']) && (
                <Grid item justify="center" xs={6} sm={4} md={3} lg={3} xl={2} className={classes.active}>
                  <QCXCardMenu
                    title="Follow Up"
                    link='/importacao/agenciamento/maritimo/follow-up'
                    icon={DynamicFeedIcon}
                    timeout={3000}
                    onClick={() => {
                      dispatch(setHouseHblType());
                    }}
                  />
                </Grid>
              )}

              {userHasAnyRole(['agenciamento-importacao-maritimo']) && (
                <Grid item justify="center" xs={6} sm={4} md={3} lg={3} xl={2} className={classes.active}>
                  <QCXCardMenu
                    title="BL"
                    link='/importacao/agenciamento/maritimo/bl'
                    icon={DynamicFeedIcon}
                    timeout={3000}
                    onClick={() => {
                      dispatch(setBlType());
                    }}
                  />
                </Grid>
              )}
              
              {userHasAnyRole(['agenciamento-importacao-maritimo']) && (
                <Grid item justify="center" xs={6} sm={4} md={3} lg={3} xl={2} className={classes.active}>
                  <QCXCardMenu
                    title="HBL"
                    link='/importacao/agenciamento/maritimo/hbl'
                    icon={DynamicFeedIcon}
                    timeout={3000}
                    onClick={() => {
                      dispatch(setHouseHblType());
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </QCXFocusLock>
        </Grid>

      </QCXMainLayout>
    </>
  );
}
